namespace advisorop.components.servicer{

    export class WorkflowMonitorSelectorController {

        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;
        advisoryFirmId: number;
        workflows: domains.IWorkflowMaster[];
        selWorkflow;
        workflowMonitorController: components.servicer.WorkflowMonitorController;


        static $inject = ["advisoryFirmApi", "workflowApi"];
        constructor(private advisoryFirmApi: services.AdvisoryFirmApi,
            private workflowApi: services.WorkflowApi) {
        }

        firmChanged(): void {console
            this.advisoryFirmId = this.selFirm.id;
            this.loadWorkflows();
        }

        loadWorkflows(): void {
            this.workflows = [];
            this.workflowApi.getWorkflows(this.advisoryFirmId, false)
                .then((response) => {
                    if (response.data.length)
                        this.workflows = response.data;
                    //console.log("WORKFLOWS ARE:", this.workflows);
                }).
                catch(err => {
                    toastr.error("Cannot fetch workflows for this advisory firm!");
                });
        };

        workflowChanged(): void {
            this.workflowMonitorController.loadMonitor(this.selWorkflow.id);
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }

        bindWorkflowMonitor(ctrl: components.servicer.WorkflowMonitorController): void {
            this.workflowMonitorController = ctrl;
        };
    }

    class WorkflowMonitorSelector implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = WorkflowMonitorSelectorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/workflow-monitor-selector.html";
        }
    }
    angular.module(Constants.APP).component("workflowMonitorSelector", new WorkflowMonitorSelector());
}